import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _jc-c" }
const _hoisted_2 = { class: "_flex _gap-2 _gap-3--m _pa-2 _pa-3--m _ai-c _fd-c _fd-r--m" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "_flexcol gfu-1of1" }
const _hoisted_5 = {
  class: "gfu-project-update__counter",
  "data-qa": "backer-center-update:SequenceNumber"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  class: "_my-1",
  "data-qa": "backer-center-update-abstract"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  class: "gfu-link-underline__content _ttl",
  "data-qa": "backer-center-update:ReadMore"
}
const _hoisted_10 = { class: "_flex _ma-2 _ma-3--m" }
const _hoisted_11 = { "data-qa": "backer-center-update:LikesCount" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_backer_center_header = _resolveComponent("backer-center-header")
  const _component_base_divider = _resolveComponent("base-divider")
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, {
    content: "",
    class: "_flexcol",
    "data-qa": `updates-feed-card:${$props.projectUpdateID}`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_backer_center_header, { class: "_pa-2 _pa-3--m" }, _createSlots({
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_base_text, {
              as: "a",
              level: "b1",
              href: $props.projectUrl,
              "data-qa": "backer-center-update:ProjectName"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.projectName), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["href"]),
            _createVNode(_component_base_text, {
              as: "div",
              level: "caption",
              href: $props.projectUrl,
              class: "_tc--light"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($options.formattedDate), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["href"])
          ])
        ]),
        _: 2 /* DYNAMIC */
      }, [
        ($props.projectImageUrl)
          ? {
              name: "prefix",
              fn: _withCtx(() => [
                _createVNode(_component_backer_center_thumbnail, {
                  "image-url": $props.projectImageUrl,
                  url: $props.projectUrl,
                  name: $props.projectName
                }, null, 8 /* PROPS */, ["image-url", "url", "name"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1024 /* DYNAMIC_SLOTS */),
      _createVNode(_component_base_divider, { class: "_my-0" }),
      _createElementVNode("div", _hoisted_2, [
        ($options.hasUpdateImage)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: $props.projectUpdateUrl
            }, [
              _createVNode(_component_base_image, {
                width: $options.updateImageSize,
                height: $options.updateImageSize,
                src: $props.imageUrl,
                loading: "lazy",
                alt: $props.title,
                class: "_rounded--common _bxsh--base"
              }, null, 8 /* PROPS */, ["width", "height", "src", "alt"])
            ], 8 /* PROPS */, _hoisted_3))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectUpdates.UpdateSequenceNumberLabel, $props.sequenceNumber)), 1 /* TEXT */),
          _createElementVNode("a", { href: $props.projectUpdateUrl }, [
            _createVNode(_component_base_title, {
              as: "h2",
              class: "_my-1",
              "data-qa": "backer-center-update-title"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ], 8 /* PROPS */, _hoisted_6),
          _createElementVNode("p", _hoisted_7, _toDisplayString($props.abstract), 1 /* TEXT */),
          _createElementVNode("a", {
            href: $props.projectUpdateUrl,
            class: "gfu-link gfu-link-underline _tc--accent"
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.Resources.Common.ReadMoreActionButton), 1 /* TEXT */),
            _createVNode(_component_base_icon, {
              name: "chevron-right",
              class: "_ml-h"
            })
          ], 8 /* PROPS */, _hoisted_8)
        ])
      ]),
      _createVNode(_component_base_divider, { class: "_my-0" }),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_base_icon, { name: "thumbs-up" }),
        _createElementVNode("span", _hoisted_11, " " + _toDisplayString($props.likesCount), 1 /* TEXT */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data-qa"]))
}